import { render, staticRenderFns } from "./addScore.vue?vue&type=template&id=56de97a0&scoped=true"
import script from "./addScore.vue?vue&type=script&lang=js"
export * from "./addScore.vue?vue&type=script&lang=js"
import style0 from "./addScore.vue?vue&type=style&index=0&id=56de97a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56de97a0",
  null
  
)

export default component.exports